"use client";

import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCities } from "@lib/redux/slices/citiesSlice"; // Adjust path
import { setProfile, ProfileData } from "@lib/redux/slices/profileSlice"; // Adjust path
import { filterSafeProfileData } from "@utils/profileDataFilter";
import type { RootState } from "@lib/redux/store"; // Adjust path
import { getUTMParams } from "@utils/utmParams";

interface ClientInitializerProps {
  cities: any[];
  profile: ProfileData | null;
}

const ClientInitializer = ({ cities, profile }: ClientInitializerProps) => {
  const dispatch = useDispatch();
  const citiesExist = useSelector(
    (state: RootState) => !!state.cities.list.length
  );
  const isAuthenticated = useSelector(
    (state: RootState) => state.profile.isAuthenticated
  );
  const didInit = useRef(false);

  if (typeof window !== "undefined" && profile?.contact_no) {
    sessionStorage.setItem("contact_number", profile?.contact_no);
  }

  useEffect(() => {
    // Run only once on mount
    if (didInit.current) return;
    didInit.current = true;
    getUTMParams();
    if (!citiesExist && cities?.length) {
      dispatch(setCities(cities));
    }

    if (!isAuthenticated && profile) {
      // Filter profile data before storing in Redux
      const safeProfile = filterSafeProfileData(profile);
      dispatch(setProfile(safeProfile));
    }
  }, []);

  return null;
};

export default ClientInitializer;
